import { AppBarState } from './app-bar-state';

export default class AppBarStateObservable {
  appBarState: AppBarState | null;
  constructor() {
    this.appBarState = null;

    document.querySelector('app-bar')!.addEventListener('appBarStateChanged', (newState) => {
      this.appBarState = (newState as { detail?: AppBarState }).detail as AppBarState;
      this.notify(this.appBarState);
    });
  }

  private notify(appBarState: AppBarState) {
    this.observers.forEach((observer) => {
      observer(appBarState);
    });
  }

  private observers: ((state: AppBarState) => void)[] = [];

  public attach(observer: (state: AppBarState) => void) {
    if (!this.observers.find((_) => _ === observer)) {
      this.observers.push(observer);
    }
  }

  public detach(observer: (state: AppBarState) => void) {
    this.observers = this.observers.filter((_) => _ !== observer);
  }
}
